import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-white text-gray-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-gray-200 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-gray-200 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-gray-200 rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Hero Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center px-4 py-2 bg-gray-100 rounded-full text-sm font-medium">
                <Icon name="AlertTriangle" size={16} className="mr-2 text-gray-600" />
                Enterprise AI Survival Strategy
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight text-gray-900">
                AI isn't optional—
                <span className="text-gray-700">it's survival</span>
              </h1>
              
              <p className="text-xl lg:text-2xl text-gray-600 leading-relaxed">
                Open-source is your path to AI independence. Build internal capabilities, eliminate vendor lock-in, and future-proof your organization.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/ai-core-blueprint">
                <Button 
                  variant="default" 
                  size="lg"
                  className="bg-gray-900 hover:bg-gray-800 text-white font-semibold px-8 py-4"
                  iconName="Download"
                  iconPosition="right"
                  fullWidth
                >
                  Get Your AI Survival Blueprint
                </Button>
              </Link>
              
              <Button 
                variant="outline" 
                size="lg"
                className="border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-4"
                iconName="Calculator"
                iconPosition="right"
                fullWidth
              >
                Calculate Your Vendor Lock-in Risk
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-6 text-sm text-gray-600">
              <div className="flex items-center">
                <Icon name="Shield" size={16} className="mr-2" />
                Enterprise Security
              </div>
              <div className="flex items-center">
                <Icon name="Users" size={16} className="mr-2" />
                500+ Organizations
              </div>
              <div className="flex items-center">
                <Icon name="TrendingUp" size={16} className="mr-2" />
                Average 40% Cost Reduction
              </div>
            </div>
          </div>

          {/* Hero Visual */}
          <div className="relative">
            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900">AI Independence Score</h3>
                  <div className="text-2xl font-bold text-gray-700">73%</div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">Internal AI Capabilities</span>
                    <span className="text-gray-700">85%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-gray-600 h-2 rounded-full" style={{width: '85%'}}></div>
                  </div>
                  
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">Vendor Dependency Risk</span>
                    <span className="text-blue-600">45%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-blue-500 h-2 rounded-full" style={{width: '45%'}}></div>
                  </div>
                  
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">Open-Source Adoption</span>
                    <span className="text-green-600">92%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-green-500 h-2 rounded-full" style={{width: '92%'}}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;